export default __webpack_public_path__ + "static/media/logo.3570e9aa.svg";